class ResponseTextboxResponsePDFValidator {
    /**
     * Constructs a new ResponseTextboxResponsePDFValidator instance.
     * @param {Object} model - The model object to be validated.
     * @param {Object} $injector - The AngularJS injector service.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.RESPONSE-TEXTBOX-PDF';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Getter for the $translate service.
     * @returns {Object} The $translate service instance.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model based on certain conditions.
     * @param {Object} from - The source object from which validation is triggered.
     * @returns {Object} The validation result object.
     */
    validate(from) {
        let error = false;

        let preferences = this.model.getPreferences();
        let includedInPDF = preferences ? preferences.includedInPDF : undefined;

        // Attempt to get includedInPDF from object properties if not found in preferences
        if (typeof includedInPDF === 'undefined') {
            let objTypeProps = ContentObjectRegistryService.getObjectProperties(this.model.getObjectType());
            if (objTypeProps && objTypeProps.obj && objTypeProps.obj.preferences) {
                includedInPDF = objTypeProps.obj.preferences.includedInPDF;
            }
        }

        // Set error to true if includedInPDF is false
        if (includedInPDF === false) {
            error = true;
        }

        return {
            'onSheetBlur':      true,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced validation check is set.
     * @returns {boolean} The status of the forced check.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'ResponseTextboxResponsePDFValidator';
    }
}

export default ResponseTextboxResponsePDFValidator;